import { render, staticRenderFns } from "./CeisaBarangImporTransaksi.vue?vue&type=template&id=27613b3b&"
import script from "./CeisaBarangImporTransaksi.vue?vue&type=script&lang=js&"
export * from "./CeisaBarangImporTransaksi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports